<template>
  <div class="py-4 flex leading-6">
    COPYRIGHT 2020, {{ appName }}. ALL RIGHTS RESERVED. GAMBLING CAN BE
    ADDICTIVE, PLEASE PLAY RESPONSIBLY. FOR MORE INFORMATION ON
    SUPPORT TOOLS, PLEASE VISIT OUR RESPONSIBLE GAMBLING PAGE
    PAYMENT SUPPORTED BY
  </div>
</template>
<script setup>
const appName = import.meta.env.VITE_APP_NAME
</script>
